export const START_LESSON = 'START_LESSON';
export const SHOW_CHARACTER = 'SHOW_CHARACTER';

// export const START_LESSON = 'START_LESSON';